export class SortingService {

  byResult (ascending) {
    return function (a, b) {

      // equal items sort equally
      if (a.result === b.result) {
        if(a.rate === b.rate) {
          // equal items sort equally
          return 0;
        } else {
          // Check sorting by rating
          if (ascending) {
            return a.rate < b.rate ? -1 : 1;
          }
          // if descending, highest sorts first
          return a.rate < b.rate ? 1 : -1;
        }
      }

      // nulls sort after anything else
      if (a.result === null) {
        return ascending ? -1 : 1;
      }
      if (b.result === null) {
        return ascending ? 1 : -1;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.result < b.result ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.result < b.result ? 1 : -1;
    };
  }

  byRating(ascending) {
    return function (a, b) {

      // equal items sort equally
      if (a.rate === b.rate) {
        if(a.result === b.result) {
          // equal items sort equally
          return 0;
        } else {
          // Check sorting by result
          if (ascending) {
            return a.result < b.result ? -1 : 1;
          }
          // if descending, highest sorts first
          return a.result < b.result ? 1 : -1;
        }
      }

      // nulls sort after anything else
      if (a.rate === null) {
        return ascending ? -1 : 1;
      }
      if (b.rate === null) {
        return ascending ? 1 : -1;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.rate < b.rate ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.rate < b.rate ? 1 : -1;
    };
  }

  byResultProgress(ascending) {
    return function (a, b) {
      // equal items sort equally
      if (a.resultProgressSincePrevious === b.resultProgressSincePrevious) {
        return 0;
      }

      // nulls sort after anything else
      if (a.resultProgressSincePrevious === null) {
        return ascending ? -1 : 1;
      }
      if (b.resultProgressSincePrevious === null) {
        return ascending ? 1 : -1;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.resultProgressSincePrevious < b.resultProgressSincePrevious ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.resultProgressSincePrevious < b.resultProgressSincePrevious ? 1 : -1;
    };
  }

  byRateProgress(ascending) {
    return function (a, b) {
      // equal items sort equally
      if (a.rateProgressSincePrevious === b.rateProgressSincePrevious) {
        return 0;
      }
      // nulls sort after anything else
      if (a.rateProgressSincePrevious === null) {
        return ascending ? -1 : 1;
      }
      if (b.rateProgressSincePrevious === null) {
        return ascending ? 1 : -1;
      }
      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.rateProgressSincePrevious < b.rateProgressSincePrevious ? -1 : 1;
      }
      // if descending, highest sorts first
      return a.rateProgressSincePrevious < b.rateProgressSincePrevious ? 1 : -1;
    };
  }

  byLatestResult (ascending) {
    return function (a, b) {

      if (a.results[0].result === b.results[0].result) {
        if(a.results[0].rate === b.results[0].rate) {
          // equal items sort equally
          return 0;
        } else {
          // Check sorting by rating
          if (ascending) {
            return a.results[0].rate < b.results[0].rate ? -1 : 1;
          }
          // if descending, highest sorts first
          return a.results[0].rate < b.results[0].rate ? 1 : -1;
        }
      }

      // nulls sort after anything else
      if (a.results[0].result === null) {
        return ascending ? -1 : 1;
      }
      if (b.results[0].result === null) {
        return ascending ? 1 : -1;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.results[0].result < b.results[0].result ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.results[0].result < b.results[0].result ? 1 : -1;
    };
  }

  byLatestRate(ascending) {
    return function (a, b) {

      // equal items sort equally
      if (a.results[0].rate === b.results[0].rate) {
        if(a.results[0].result === b.results[0].result) {
          // equal items sort equally
          return 0;
        } else {
          // Check sorting by result
          if (ascending) {
            return a.results[0].result < b.results[0].result ? -1 : 1;
          }
          // if descending, highest sorts first
          return a.results[0].result < b.results[0].result ? 1 : -1;
        }
      }

      // nulls sort after anything else
      if (a.results[0].rate === null) {
        return ascending ? -1 : 1;
      }
      if (b.results[0].rate === null) {
        return ascending ? 1 : -1;
      }

      // otherwise, if we're ascending, lowest sorts first
      if (ascending) {
        return a.results[0].rate < b.results[0].rate ? -1 : 1;
      }

      // if descending, highest sorts first
      return a.results[0].rate < b.results[0].rate ? 1 : -1;
    };
  }

  byParameter(ascending) {
    return undefined;
  }

  getSortingFunction(name) {
    switch(name) {
      case "byResult":
        return this.byResult;
      case "byRating":
        return this.byRating;
      case "byResultProgress":
        return this.byResultProgress;
      case "byRateProgress":
        return this.byRateProgress;
      case "byLatestResult":
        return this.byLatestResult;
      case "byLatestRate":
        return this.byLatestRate;
      case "byParameter":
        return this.byParameter;
      default:
        return this.byResult;
    }
  }
}

export const sortingService = new SortingService();


// WEBPACK FOOTER //
// ./src/utilities/sortingService.js